module.exports = __webpack_public_path__ + "img/left_arrow_ash_icon.c50c5252.svg";